import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import NavDrawer from './NavDrawer';
import { BLOG_CONTACT_HREF } from '../lib/siteNavigation';

export default function BlogHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="fixed top-0 w-full z-50 px-6 py-4 flex justify-between items-center bg-deep-purple/80 backdrop-blur-md border-b border-white/10">
        <Link to="/" className="flex items-center gap-2">
          <span className="text-2xl">🔥</span>
          <span className="font-extrabold text-xl tracking-tight">OurSexQuiz</span>
        </Link>
        <button
          onClick={() => setMenuOpen(true)}
          className="nav-menu-trigger"
          aria-label="Open menu"
        >
          <svg
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M4 7h16" />
            <path d="M4 12h16" />
            <path d="M4 17h16" />
          </svg>
        </button>
      </header>

      <NavDrawer
        isOpen={menuOpen}
        onClose={() => setMenuOpen(false)}
        contactHref={BLOG_CONTACT_HREF}
        onPrimaryAction={() => navigate('/#onboarding')}
        primaryActionLabel="Start Quiz"
      />
    </>
  );
}
